import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.service';
import { FormGroup,FormControl, FormArray,Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { filter } from 'rxjs/operators';
import { stringify } from 'querystring';
 

@Component({
  selector: 'app-verify-sms',
  templateUrl: './verify-sms.component.html',
  styleUrls: ['./verify-sms.component.css']
})
export class VerifySmsComponent implements OnInit {

  formAdmin: any;
  userData:any;
  userFinal:any;
  invalidCredentialMsg: string;
  qrGoogle:any;
  

  constructor(
    public authService: AuthService,
    public router: Router,
	public param: ActivatedRoute
  ) {

	this.formAdmin = new FormGroup({
		clave: new FormControl("")
	  })
  }

  ngOnInit(): void {  

 this.param.queryParams.subscribe(params => {
  this.qrGoogle = params['data']

let datos = this.qrGoogle.ok
  //console.log(datos);
  

 })
	
	

  }

 
    

	onSubmit(dataAdmin:any){
		console.log(dataAdmin);
	
		this.authService.postRegistro(dataAdmin)
			.subscribe (res=>{
			  console.log (res);
			  if (res) {
				this.userData = res;
				localStorage.setItem('sfeJfsld8dsKld5lRld', this.userData.token);
				alert ('Usuario creado')
				this.formAdmin.reset()
				this.router.navigate(['admin/verify-sms']);
				//this.router.navigate(['listadoProf']);
				//JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
			  } else {
				localStorage.setItem('sfeJfsld8dsKld5lRld', "null");
				this.formAdmin.reset()            //JSON.parse(localStorage.getItem('sfeJfsld8dsKld5lRld'));
			  }
			});   
	  }

}
